import {Injectable} from "@angular/core";
import {AbstractControl, ValidationErrors} from "@angular/forms";

@Injectable({
  providedIn: 'root'
})
export class PasswordMatchValidatorUtils {

  passwordMatchValidator(control: AbstractControl): ValidationErrors | null {
    const newPassword = control.get('newPassword');
    const confirmPassword = control.get('confirmPassword');

    return newPassword.value.length > 0 && confirmPassword.value.length > 0 && newPassword.value !== confirmPassword.value
      ? { passwordMismatch: true }
      : null;
  }
}
